var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "d-block pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _vm.migrations.length > 1
            ? _c(
                "div",
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "py-3 px-1 mb-3",
                      attrs: {
                        type: "warning",
                        color: "error lighten-1",
                        role: "note"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prepend",
                            fn: function fn() {
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass:
                                      "mx-2 d-none d-sm-block white--text"
                                  },
                                  [_vm._v("mdi-alert-circle-outline")]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1935957781
                      )
                    },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hidden-xs-only"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-space-between align-center"
                              },
                              [
                                _vm._v(
                                  " You have multiple migrations scheduled for your services. "
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "flex-shrink mr-2",
                                    attrs: {
                                      color: "error",
                                      to: {
                                        name: "migrations"
                                      },
                                      role: "link"
                                    }
                                  },
                                  [_vm._v(" View Migrations ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "div",
                _vm._l(_vm.migrations, function(migration) {
                  return _c(
                    "v-alert",
                    {
                      key: "ma-".concat(migration.id),
                      staticClass: "py-3 px-1 mb-3",
                      attrs: {
                        type: "warning",
                        color: "error lighten-1",
                        role: "note"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prepend",
                            fn: function fn() {
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass:
                                      "mx-2 d-none d-sm-block white--text"
                                  },
                                  [_vm._v("mdi-alert-circle-outline")]
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "append",
                            fn: function fn() {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      icon: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.hideAlert(migration.id)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "white"
                                        }
                                      },
                                      [_vm._v("mdi-close")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass: "hidden-xs-only"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-space-between align-center"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(migration.service_name) +
                                    " has a migration scheduled. This banner will go away once the migration is completed. "
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "flex-shrink mr-2",
                                    attrs: {
                                      color: "error",
                                      to: {
                                        name: "migration_details",
                                        params: {
                                          id: migration.id
                                        }
                                      },
                                      role: "link"
                                    }
                                  },
                                  [_vm._v(" View ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ],
                    2
                  )
                }),
                1
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }